import React from "react"
import { useDispatch } from "react-redux"
import {
  showAllDepartmentIds,
  setNoLocationAnswerOption,
  hideAllDepartmentIds,
} from "reduxSlices/formSubmissionTableSlice"
import MassSelection from "shared/MassSelection"
import { SidebarCollapsibleContent } from "shared/Sidebar"
import SubmissionAnswerLocationList from "./SubmissionAnswerLocationList"

const SubmissionAnswerLocationFilter = () => {
  const dispatch = useDispatch()

  const handleSelectAll = () => {
    dispatch(showAllDepartmentIds())
    dispatch(setNoLocationAnswerOption(true))
  }

  const handleUnselectAll = () => {
    dispatch(hideAllDepartmentIds())
    dispatch(setNoLocationAnswerOption(false))
  }

  return (
    <SidebarCollapsibleContent title="Filter By Answer Location">
      <div className="flex flex-col gap-2">
        <MassSelection
          deselectAll={() => handleUnselectAll()}
          selectAll={() => handleSelectAll()}
        />
        <SubmissionAnswerLocationList className="mb-4" />
      </div>
    </SidebarCollapsibleContent>
  )
}

export default SubmissionAnswerLocationFilter
